import { combineReducers } from 'redux';
import * as types from './types';
import SearchModelProductClass from 'src/model/searchModelProduct.model';
import { retrieveSearchText, saveSearchText } from 'src/utils/persistence';

/* state shape
SearchState {
  loading: boolean,
  searchText: string,
  searchResults: SearchModelProductClass,
  error: any,
  page: number
} */

const savedSearchText = retrieveSearchText();

const loading: boolean = false;
const searchText: string = savedSearchText == null ? '' : savedSearchText;
const searchResults: SearchModelProductClass = new SearchModelProductClass();
const error: any = null;
const page: number = 0;

const searchTextReducer = (state = searchText, { type, payload }: any) => {
  switch (type) {
    case types.SEARCH_TEXT:
      saveSearchText(payload);
      return payload;
    default:
      return state;
  }
};

const searchPageReducer = (state = page, { type, payload }: any) => {
  switch (type) {
    case types.SEARCH_PAGE:
      return payload;
    default:
      return state;
  }
};

const searchResultsReducer = (
  state = searchResults,
  { type, payload }: any
) => {
  switch (type) {
    case types.SEARCH_RESULTS:
      return payload;
    default:
      return state;
  }
};

const loadingReducer = (state = loading, { type, payload }: any) => {
  switch (type) {
    case types.SEARCH_LOADING:
      return payload;
    default:
      return state;
  }
};

const errorReducer = (state = error, { type, payload }: any) => {
  switch (type) {
    case types.SEARCH_ERROR:
      return payload;
    default:
      return state;
  }
};

const searchReducer = combineReducers({
  text: searchTextReducer,
  page: searchPageReducer,
  results: searchResultsReducer,
  loading: loadingReducer,
  error: errorReducer
});

export default searchReducer;
